<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="75px" height="75px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
    <image id="image0" width="100" height="100" x="0" y="0" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
      AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACPVBMVEUAAAD/fwD/hQD/hgD/
      hwD/hQD/hgD/hgD/hAD/hQD/hQD/gwD/jQD/hwD/hgD/hQD/hQD/fwD/hwD/hQD/hgD/hQD/hgD/
      hgD/hQD/hgD/hAD/hgD/hgD/hQD/iwD/hQD/hgD/hQD/fwD//wD/hAD/hQD/hgD/hQD/iAD/hgD/
      hwD/gwD/hgD/hQD/hQD/hAD/hgD/hQD/hQD/hQD/fwD/hQD/hgD/hQD/hAD/iAD/hgD/hwD/ggD/
      hQD/hQD/iAD/fwD/hQD/hQD/hQD/hQD/gwD/hQD/hQD/hQD/hgD/hgD/iQD/hQD/hQD/hgD/hQD/
      hQD/iAD/hgD/hQD/hgD/hQD/hgD/hgD/hAD/hQD/hgD/hQD/hgD/hgD/hQD/hwD/qgD/hQD/hgD/
      fwD/hQD/hQD/hQD/hgD/hQD/hQD/hAD/hgD/hQD/hAD/hgD/hgD/hgD/hwD/hgD/hAD/hAD/iQD/
      hQD/hgD/hQD/hQD/hQD/hgD/hQD/hQD/hgD/hQD/mQD/hQD/hwD/hQD/hwD/hgD/fwD/hQD/hwD/
      hQD/hQD/hAD/hAD/hQD/hgD/fwD/hgD/hQD/hQD/hgD/hwD/hQD/hQD/hQD/hgD/hgD/hQD/hgD/
      iAD/hQD/hgD/hgD/hgD/hgD/hQD/hwD/iAD/hgD/hgD/hgD/hgD/hQD/hgD/hQD/hgD/hQD/hgD/
      hQD/hgD/hQD/hgD/jAD/fwD/gwD/hgD/hgD/hQD/hgD/hQD/iAD/hAD/hgD///8pG0nKAAAAvXRS
      TlMABG/cQNLYSBuisyEJd/P2iAxR3/2dJrbMOTLFviwLgPnsAgFe5/uRD+gzOhP8403e/hfwBkHT
      2Ukc72Ynt78tEI/pu6wfXMHy8VsNtVrCzigpwCriPTfRNvj3VFerUGQDqvUKfPQVNevUMM1YNFmF
      mlWDRxkaReblc1aQcXhK+gVSIC4x2g7bLz+bYmCLhwjHZ42nT8i5po60fuAr4X3k6k47IjzLoV9h
      nomTlG2psYFD1RQSHc/Jhq3QHjjUMICMAAAAAWJLR0S+pNyDwwAAAAlwSFlzAAALEwAACxMBAJqc
      GAAAAAd0SU1FB+kHGRAGGtWw2WMAAAUISURBVGje7Zn7X1RFFMBnV8sUlAQMwwTlLlfBFnbVjChL
      UFAEQ0pEFpAFNB+RKYGapeQjy9ReYg9RNyvL3k/tuf9b58zszN7H3Lt3lssn+7Tnlz3nzJnzvXfu
      mblzdwjJyX9dAsEZM4KB6WXMvCcJcu+saUTcNzuZkjl504TInzsvKaTg/vnTwSgsotmLFywopkpR
      oe+IB0rYHSx8kJDSRUx/aLGviLLyJTTt0mAFmlqokpr6suW+IbRQlTWnhTp1qZaOjhi/FT4gHl4W
      pslqQtaW2ghtiM5eOUVEILjKuWJ5Tc8rXz0VxiNr3Ocen52P1mWNeCyVwm0VYetM1ksAH4z6ua6D
      EXh8afZLgPfH6lwaGeSJtekJnln4EvDkUwqIdQ16ah30ONUqUuF6wzrPkEax2HrtITo0eobQ8PWq
      kPVKl0XYU1SFsFrxDqH1qAyhVe8ZsqEp3VEFQkjTBs8Qc0e/Y3OQ/xtEa964qWXjZs0viCxfa2pX
      UNLqD0SWTyvh61ub5gdEmq85vcfd4gdEmu9psNq3drTDzzN+QKT5WsDqIORZ+FnlB0Saj4eYQ7OH
      SPPlIDlIDpKD5CDKEBW5eyE1aoxtWUHqtikxZmUFyV7uFojWGQx2atkk5z0zQ7Z34U/XDnWG6JkR
      UtjNHmSsR5XRw3sWZoTEeLnovWqMXv4HQ7LbFcJnRl+fOoUxWE8+a6SQnexi+gkJ6YoUytBDhPSz
      Ydhpg4TBiIvQgXQnzxRDeJ/Q4qCFRcggWENU28UhahRjMEJ2Ua0MtN0iBv8We45q2/EOQ6oUY2gI
      M+yh6krQ9oqgfWDtZ2p7OtwzxRhI9eeZvxTUNSIKP4yGmbqjW5liY8ReYA0HQG8TYS+CdTClH9IV
      KTaGzqfxQTBGRNxLYLWMOnbqVWPw8DH8FjosAgNHkoZvSCWKc3AFPoSj8XToy1gSDc4djzkxjjlf
      0CuY81VD7GosquRxR8oSh3+wT4w7Mo5jxoWvGaPz8ECk+KQjZXC/jFE66Mg4icdFlafM8afrcXqe
      kVEO4Krz+lk7Y/kbuG4MyxhndoNZ/6a1xzk8dakZlVH6o4YSN8hb4I6elzFGcQ8yPtPe5QIdxCFu
      9mC3cDPVL+JY2l6V1Tgib1OVTq7wZt7yzruY6z3ZCL+PLZfEy51d3ASqgcugrrXGfwDORXHUJsz3
      oX2ImT6SMUj8Y2y7QkyUSTbE8FiiV83hi2EQ9dNUvWaeTNcxT1tcCiGteCQTPWSiJJg6YL+0Brxv
      piZMjB58hPvOEgfJ+wSrtVrYNyKTtUz7FBoiplhtElypQ7PayciN9KPCut77GXGUz3ENTozZGzRc
      eDqMnqsYKdmdjSVw8nYSF6EldnPI3vAF+L80Om6B4yt7XP5NzHCLuMrXGDNgv8IguL8xOr4Fx3f2
      O/4e+190Z5CKHzDqR5v/sOkFRNiL7idbWDn2npPxaGc+7jWjW6xufARdRge+srdao2hh/ezhQLgJ
      D3oLrPP7F3BWGR1YiL9agvYUgLPxFPEgK7DEKm+bnbi9aTE68Hww3xwzijvQ8XNeGPAmwpu+U2by
      BbC/0aHzDaGQ/N9S209v8jtG/2F+fKYtp8Qm2qWkWDC9CCvEEeKW1AYZcVuxZFJ2x1ZimSDDOMZ/
      Kh3N3sbXcaNbUquN607VXyoM2BTHLJCIZYW02gCJ/a3GgI3ItSMTRrsukahzs2uPFp1QZeTk35N/
      AH/cqn8DWBujAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI1LTA3LTI1VDE2OjA2OjI2KzAyOjAwGEbj
      iAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNS0wNy0yNVQxNjowNjoyNiswMjowMGkbWzQAAAAASUVO
      RK5CYII="
    />
  </svg>
</template>

<script>
export default {};
</script>
